import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponseWithQData } from "../../../types/common";
import { IContactPayload, IDeleteDataResponseAndPayload } from "../../../types/api/contact";

export async function listContact(
  qData: QData,
): Promise<AxiosResponse<TResponseWithQData<IContactPayload[]>>> {
  return axios.get(API_ENDPOINTS.CONTACT_LIST, {
    params: qData,
  });
}

export async function deleteContact({
  ids,
}: IDeleteDataResponseAndPayload): Promise<
  AxiosResponse<TResponseWithQData<IDeleteDataResponseAndPayload>>
> {
  return axios.post(API_ENDPOINTS.CONTACT_DELETE, {ids} );
}
